/**
 * SPA entry — mounts the TanStack Router into #app. This file replaces what
 * TanStack Start used to handle automatically. No SSR, no Nitro, no edge
 * adapter: the whole web app is a static bundle that gets dropped on
 * Cloudflare Pages.
 */
import "./stale-tzdata-shim";

import { StrictMode } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import "./styles.css";

import { initWebSentry } from "~/observability/sentry";
import { initWebPostHog } from "~/observability/posthog";

import { getRouter } from "./router";

initWebSentry();
initWebPostHog();

const rootElement = document.getElementById("app");
if (!rootElement) {
  throw new Error("Root element #app not found in index.html");
}

const router = getRouter();

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
